<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.committee.new.title"></sm-page-header>
  <div class="content">
    <sm-form-builder [formObject]="formObject" class="w-full px-4" (blur)="onFieldBlur()"></sm-form-builder>
    <div class="flex justify-end gap-2">
      <p-button [label]="'settings.committee.new.add' | translate" (click)="addCommittee()" [disabled]="(isFormValid$ | async) === false" />
      <p-button [label]="'settings.committee.new.reset' | translate" severity="secondary" (click)="reset()" />
    </div>
  </div>
</div>
